import styled from 'styled-components'
import { FlexContainer } from '../../../../../../components'

export const Container = styled(FlexContainer)`
   width: calc(100% / 2 - 89px);
   gap: 17px;
`
